// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"SignUpForm_termsContainer__A8GJA","signUpForm":"SignUpForm_signUpForm__2knA1"};